export enum StepNames {
    MobileAccountLookup = 'MobileAccountLookup',
}
